import { useTranslation } from 'react-i18next'
/**
 * @return {JSX.Element} Footer
 */
export default function Footer() {
  const { t } = useTranslation()
  return (
    <footer className="inline-grid px-2 py-3 mt-auto text-center select-none mb-11 lg:mb-0 landscape:mb-0 lg:landscape:mb-0">
      <p className="duration-500 ease-in-out delay-300 md:text-xxs text-xxxs text-primary">
        2021 - {new Date().getFullYear()}{' '}
        {t(`© No Copyrights. Free The World | Decentralize Everything`)}
      </p>
    </footer>
  )
}
